import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
function ConfigurationItemOverviewReportViewModel(parent) {
    var self = this;
    self.parent = parent;
    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.ConfigurationItemId = ko.observable();
    self.ConfigurationItemName = ko.observable();
    self.Download = function () {
        if (self.ConfigurationItemId() == null) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("SelectOneObject"), "info");
        }
        else {
            parent.TabPage.IsLoading(true);
            Bao.post("SynosetReportCenter/ConfigurationItemOverviewReportDownload", JSON.stringify({
                ConfigurationItemId: self.ConfigurationItemId(),
                maxLevel: 20,
                reportTemplateId: null
            }), function (result) {
                parent.TabPage.IsLoading(false);
                if (result.Result == true) {
                    baoRouter.setHash("document/" + result.Message);
                }
            });
        }
    };
    self.init = function () {
        var def = $.Deferred();
        self.Initialized(true);
        def.resolve();
        return def.promise();
    };
    self.loaded = function () { };
}
export default ConfigurationItemOverviewReportViewModel;